// extracted by mini-css-extract-plugin
module.exports = {"linkToggle":"MapPage__linkToggle","toggleContainer":"MapPage__toggleContainer","toggleButtonActive":"MapPage__toggleButtonActive","toggleButton":"MapPage__toggleButton"};